<template>
    <header>
        <div class="container">
            <a class="lang_change" @click="changeLang()">{{langText}}</a>
            <a href="../index.html"><img src="/img/logo-header.png" class="logo"></a>
            <a class="menu-link" @click="show = !show" v-if="!blockMenu">
                <svg width="30" height="24">
                    <g clip-path="url(#clip_0)">
                        <path fill="rgb(255,255,255)" stroke="none" transform="translate(0.194824 0)" d="M1.94805 3.8961L27.6623 3.8961C28.7383 3.8961 29.6104 3.02404 29.6104 1.94805C29.6104 0.872065 28.7383 0 27.6623 0L1.94805 0C0.872065 0 0 0.872065 0 1.94805C0 3.02404 0.872065 3.8961 1.94805 3.8961Z"/>
                    </g>
                    <g clip-path="url(#clip_1)">
                        <path fill="rgb(255,255,255)" stroke="none" transform="translate(0.389648 9.74026)" d="M27.6623 0L1.94805 0C0.872065 0 0 0.872065 0 1.94805C0 3.02404 0.872065 3.8961 1.94805 3.8961L27.6623 3.8961C28.7383 3.8961 29.6104 3.02404 29.6104 1.94805C29.6104 0.872065 28.7383 0 27.6623 0Z"/>
                    </g>
                    <g clip-path="url(#clip_2)">
                        <path fill="rgb(255,255,255)" stroke="none" transform="translate(0.389648 19.4805)" d="M27.6623 0L1.94805 0C0.872065 0 0 0.872065 0 1.94805C0 3.02404 0.872065 3.8961 1.94805 3.8961L27.6623 3.8961C28.7383 3.8961 29.6104 3.02404 29.6104 1.94805C29.6104 0.872065 28.7383 0 27.6623 0Z"/>
                    </g>
                </svg>
            </a>
        </div>
        <div class="menu-block" :class="{open: show}" v-if="!blockMenu">
            <div class="container">
                <svg width="24" height="24" @click="show = !show">
                    <g clip-path="url(#clip_0)">
                        <path fill="rgb(255,255,255)" stroke="none" transform="matrix(0.9917 0 0 0.9917 0.45752 0.995697)" d="M0.667689 23.193C1.09431 23.6197 1.67455 23.8607 2.27818 23.8607C2.88182 23.8607 3.45995 23.6197 3.88655 23.193L11.9303 15.1491L19.974 23.193C20.8614 24.0826 22.3033 24.0826 23.1929 23.193C24.0824 22.3035 24.0824 20.8615 23.1929 19.9741L15.1491 11.9301L23.1929 3.88611C24.0824 2.99871 24.0824 1.55669 23.1929 0.667151C22.3033 -0.222384 20.8614 -0.222384 19.974 0.667151L11.9303 8.71113L3.88655 0.667151C2.99917 -0.222384 1.5572 -0.222384 0.667689 0.667151C-0.221817 1.55669 -0.221817 2.99871 0.667689 3.88611L8.71142 11.9301L0.667689 19.9741C0.241066 20.4007 0 20.9788 0 21.5825C0 22.1862 0.241044 22.7664 0.667689 23.193L0.667689 23.193Z"/>
                    </g>
                </svg>
                <nav v-if="menus.length > 0">
                    <template v-for="menu in menus">
                        <a :class="{active: checkPath(menu.name)}" @click="$router.push(setRouterPath(menu)); show = !show" :key="menu.id">{{menu.title}}</a>
                    </template>
                    <span>{{beforeLogo}}</span>
                    <a href="http://parachutecanada.org" target="_blank"><img :src="'/img/big-logo-white-'+lang+'.png'" alt=""></a>
                    <span>{{afterLogo}} <a href="http://parachutecanada.org" target="_blank">parachutecanada.org</a></span>
                </nav>
            </div>
        </div>
    </header>
</template>
<script>
export default {
    name: 'pageheader',
    data: function () {
        return {
            show: false,
            lang: localStorage.lang ? localStorage.lang  : 'en',
            menus: [],
            langText: localStorage.lang == 'en' ? 'Français' : 'English',
            beforeLogo: localStorage.lang == 'en' ? 'Concussion Ed is proudly brought to you by:' : 'Concussion Ed vous est fièrement présenté par:',
            afterLogo: localStorage.lang =='en' ? 'Visit Us Online at' : 'Visitez-nous en ligne à',
            blockMenu:true
        }
    },
    mounted: function() {
        this.getMenu()
    },
    methods: {
        getMenu: function(){
            this.axios.get(process.env.VUE_APP_URL+'sections', {params:{language:this.lang}})
            .then(response => {
                this.menus = response.data
            })
        },
        mounted: function() {
            this.getMenu()
        },
        checkPath: function(name) {
            return this.$route.path.indexOf(name) !== -1
        },
        setRouterPath: function(menu){
            let path = {}
            if (menu.name == 'checklist') {
                path = {path: '/checklist'}
            } else if(menu.name != 'track') {
                path = menu.customizable === 1 ? {path:'/page/'+menu.name} : {path: '/settings/'+menu.name}
            } else {
                path = {path: '/track/'+menu.name}
            }
            return path
        },
        changeLang: function() {
            localStorage.lang = localStorage.lang == 'en' ? 'fr' : 'en'
            location.reload()
        }
    }
}
</script>

